<template>
    <div class="cover-content table-wrapper">
        <!-- <high-search> -->
        <Form ref="formInline" :model="formInline" inline class="form-list" :label-width="77" label-position="right">
            <Row :gutter="16">
                <!--<Col span="6">-->
                    <!--<FormItem label="考勤时间: ">-->
                        <!--<DatePicker type="month" placeholder="请选择考勤开始时间" v-model="formInline.startDate" style="width: calc(50% - 6px);" @on-change='handleStartDate' :options='{-->
                            <!--disabledDate: disabledDateStart-->
                        <!--}'></DatePicker>-->
                        <!--<DatePicker type="month" placeholder="请选择考勤结束时间" v-model="formInline.endDate" style="width: calc(50% - 6px);margin-left:12px;" @on-change='handleEndDate' :options='{-->
                            <!--disabledDate: disabledDateEnd-->
                        <!--}'></DatePicker>-->
                    <!--</FormItem>-->
                <!--</Col>-->
                <Col span="6">
                    <FormItem label="项目名称: ">
                        <Input v-model="formInline.projectName" placeholder="请输入项目名称"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <!--<FormItem label="人员类型: ">-->
                        <!--<Select v-model="formInline.workRole" placeholder="请选择人员类型">-->
                            <!--<Option value="20">建筑工人</Option>-->
                            <!--<Option value="10">管理人员</Option>-->
                        <!--</Select>-->
                    <!--</FormItem>-->
                    <FormItem label="人员类型:" prop="workRole">
                        <RadioGroup v-model="formInline.workRole">
                            <Radio label="0">全部</Radio>
                            <Radio label="10">管理人员</Radio>
                            <Radio label="20">建筑工人</Radio>
                        </RadioGroup>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="人员姓名: ">
                        <Input v-model="formInline.workerName" placeholder="请输入人员姓名"></Input>
                    </FormItem>
                </Col>
                <Col span="6" class="high-search">
                    <FormItem :label-width="0">
                        <Button type="primary" @click="handleQuery">搜索</Button>
                        <Button style="margin-left: 20px" @click="handleReset">重置</Button>
                        <span :class='open ? "search-open" : "search-close"' @click='open = !open'>{{open ? '收起' : '展开'}} <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" /></span>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16" v-show="open">
                <!--<Col span="6">-->
                    <!--<FormItem label="人员姓名: ">-->
                        <!--<Input v-model="formInline.workerName" placeholder="请输入人员姓名"></Input>-->
                    <!--</FormItem>-->
                <!--</Col>-->
                <Col span="6">
                    <FormItem label="参建单位: ">
                        <Input v-model="formInline.corpName" placeholder="请输入参建单位"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="项目所在地:">
                        <place-select v-model="formInline.areaCode"></place-select>
                        <!--<Select v-model="formInline.curAreaCode" transfer placeholder="请选择地区">-->
                            <!--<Option v-for="(item,index) in area" :value="item.value" :key="index">{{ item.label }}</Option>-->
                        <!--</Select>-->
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="考勤时间: " prop="startDate">
                        <DatePicker type="date" placeholder="请选择考勤时间" :value="formInline.startDate" @on-change="formInline.startDate = $event" :options="pickerOption"></DatePicker>
                </FormItem>
                </Col>
            </Row>
           <!-- <Row>
                <Col span="8">
                    <Button :loading="eLoading" style="margin-bottom: 24px;" type="primary" icon="ios-exit-outline" @click="handleExport">导出</Button>
                </Col>
            </Row>-->
        </Form>
        <!-- </high-search> -->
        <div class='cover-table'>
            <Table border style="width: 100%;" :loading="loading" :columns="tableColumns" :data="tableData" highlight-row>
                <template slot-scope="{ row, index }" slot="action">
                    <span class="pointer"  @click="handleDeal('checking-inDetail',row.projectWorkerId, row.workerId)">详情</span>
                </template>
            </Table>
            <Page class='page' :total="totalCount" :page-size="pageSize" :current="page" @on-change="changePage" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total transfer>
            </Page>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import { mapState } from 'vuex';
    import tableMixin from '@/components/tableMixin';

    export default {
        mixins: [tableMixin],
        data(){
            return {
                eLoading: false,
                open: false,
                activeTabs: "0",
                formInline:{
                    startDate: '',
                    endDate: '',
                    workRole: '0',
                    projectName:'',
                    workerName:'',
                    corpName:'',
                    curAreaCode: localStorage.getItem('tenantAreaCode'),
                },
                tableColumns:[
                    { title: '序号', type: 'index', width: 70, fixed: 'left', align: 'center' },
                    { title: '姓名', key: 'workerName', minWidth: 100 },
                    { title: '身份证号', key: 'idCardNumber', minWidth:180, tooltip: true },
                    { title: '项目名称', key: 'projectName', minWidth: 210, tooltip: true },
                    { title: '项目属地', key: 'areaName', minWidth: 160, tooltip: true },
                    { title: '参建单位', key: 'corpName', minWidth: 210, tooltip: true },
                    { title: '班组名称', key: 'teamName', minWidth: 210, tooltip: true },
                    { title: '人员类型', key: 'workRole', minWidth: 100, tooltip: true },
                    // { title: '项目经理', key: 'corpName', minWidth:120 },
                    // { title: '项目总监', key: 'corpName', minWidth:120 },
                    // { title: '项目负责人', key: 'corpName', minWidth:120 },
                    { title: '考勤日期', key: 'workDate', minWidth: 120, tooltip: true },
                    { title: '最后考勤时间', key: 'workTime', minWidth: 130, tooltip: true },
                    { title: '操作', slot: 'action', fixed: 'right', align: 'center', minWidth:100 }
                ],
                tableData: [],
                pickerOption: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                }
            };
        },
        computed:{
            ...mapState(['navList','area','citys']),
        },
        created(){
            if(this.$route.query.startDate) {
                this.formInline.startDate = this.$route.query.startDate;
            }else {
                this.formInline.startDate = this.common.getDate();
            }
            this.$route.query.areaCode && (this.formInline.areaCode = this.$route.query.areaCode)
            this.formInline.projectName = this.$route.query.projectName ? this.$route.query.projectName : ''
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            disabledDateStart(val) {
                return new Date(this.formInline['endDate'] || '').getTime() < val.getTime()
            },
            disabledDateEnd(val) {
                return new Date(this.formInline['startDate'] || '').getTime() > val.getTime()
            },
            handleStartDate(val) {
                this.formInline['startDate'] = val
            },
            handleEndDate(val) {
                this.formInline['endDate'] = val
            },
            handleReset() {
                this.page = 1
                this.formInline = {
                    startDate: '',
                    endDate: '',
                    workRole: '',
                    projectName:'',
                    workerName:'',
                    corpName:'',
                    areaCode: localStorage.getItem('tenantAreaCode'),
                }
                this.getTableData()
            },
            //导出
            handleExport(){
                this.eLoading = true;
                this.axios({
                    method: 'post',
                    url:'/worker/sx/attendance/export',
                    responseType:'arraybuffer',
                    data: {
                        size: this.pageSize,
                        current: this.page,
                        ...this.formInline,
                        attendanceType: this.activeTabs,
                    },
                }).then( (response)=> {
                    this.eLoading = false;
                    this.common.download(response,'人员考勤.xls','application/vnd.ms-excel');
                }).catch(() => {
                    this.eLoading = false;
                });
            },
            /*处理操作*/
            handleDeal(name,uuid, workerId){
                this.$router.push({
                    name: name,
                    query: {
                        projectWorkerId: uuid,
                        workerId: workerId,
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                const { curAreaCode } = this.formInline
                this.formInline.endDate = this.formInline.startDate;
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/worker/sx/attendance',
                    data: {
                        areaCode: curAreaCode,
                        size: this.pageSize,
                        current: this.page,
                        attendanceType: this.activeTabs,
                        ...this.formInline,
                    }
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        this.totalCount = response.data.data.total
                        this.tableData = response.data.data.records
                    }
                }).catch(()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
